<template>
  <!-- eslint-disable -->
  <mi-list-item class="bom-validation-incomplete-result">
    <mi-list-item-section class="text-weight-light">
      <div class="bom-validation-incomplete-result__header flex">
        <!-- Planning period -->
        <mi-list-item-label>
          {{ item.rangeFrom }}
        </mi-list-item-label>
        <!-- Case number -->
        <mi-list-item-label class="q-mt-nome">
          Case {{ itemIndex + 1 }}
        </mi-list-item-label>
      </div>
      <div class="explanation-content" v-html="explanation"></div>
    </mi-list-item-section>
  </mi-list-item>
</template>

<script>
  import { onMounted, ref } from 'vue'
  import { transformExpression } from '@/utils/formatExplanation'

  export default {
    name: 'BomValidationResultsElementsIncomplete',
    components: { },
    props: {
      item: {
        type: Object,
        required: true
      },
      itemIndex: {
        type: Number,
        required: true
      }
    },
    setup(props) {
      const explanation = ref(props.item.explanation)

      onMounted(() => {
        if (explanation.value) {
          if (explanation.value.startsWith('(') && explanation.value.endsWith(')')) {
            explanation.value = explanation.value.slice(1, -1)
          }
          explanation.value = transformExpression(explanation.value)
        }
      })

      return {
        explanation
      }
    }
  }
</script>

<style lang="scss" scoped>
  // stylelint-disable declaration-no-important
  .bom-validation-incomplete-result.mi-list-item {
    border-style: solid !important;
    border-width: 1px 0 !important;
    border-color: #afafaf !important;
    padding: 20px;
  }

  .bom-validation-incomplete-result {
    &__header {
      margin: 0 0 8px;
      font-size: 14px;
      color: $mi-silver-700;
      font-weight: 500;
      justify-content: space-between;
    }

    .q-item__label {
      margin-top: 0 !important;
    }
  }
</style>
